import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, createRoutesFromElements, RouterProvider, Route, Navigate } from "react-router-dom";

import Root from "./root";

import AnalyticsContainer from "./views/analytics/analytics-container";
import AnalyticsDetail from "./views/analytics/analytics-detail";
import Account from "./views/settings/settings-account";
import ApiKeys from "./views/settings/settings-api-keys";
import ApiKeyCreate from "./views/settings/settings-api-keys/create";
import Billing from "./views/settings/settings-billing";
import CustomerContainer from "./views/customers/customer-container";
import CustomerNew from "./views/customers/customer-new";
import DashboardContainer from "./views/dashboard/dashboard-container";
import Discounts from "./views/settings/settings-discounts";
import DiscountCreate from "./views/settings/settings-discounts/create";
import ErrorPage from "./views/error-page";
import ExportContainer from './views/export/export-container';
import PaymentButtons from "./views/settings/settings-payment-buttons";
import PaymentContainer from "./views/payments/payment-container";
import PaymentNew from "./views/payments/payment-new";
import PaymentProcessors from "./views/settings/settings-payment-processors";
import PaymentProcessorCreate from "./views/settings/settings-payment-processors/create";
import PaymentProcessorEdit from "./views/settings/settings-payment-processors/edit";
import PlanContainer from "./views/plans/plan-container";
import PlanCreate from "./views/plans/plan-create";
import PlanDetail from "./views/plans/plan-detail";
import PlanGroups from "./views/settings/settings-plan-groups";
import PlanGroupCreate from "./views/settings/settings-plan-groups/create";
import PlanGroupEdit from "./views/settings/settings-plan-groups/edit";
import ProtectedRoute from "./components/protected-route";
import SettingsContainer from "./views/settings/settings-container";
import SubscriptionContainer from "./views/subscriptions/subscription-container";
import SubscriptionNew from "./views/subscriptions/subscription-new";
import SuperAdmin from "./views/superadmin";
import TransactionContainer from "./views/transactions/transaction-container";
import Users from "./views/settings/settings-users";
import UserCreate from "./views/settings/settings-users/create";
import UserEdit from "./views/settings/settings-users/edit";
import Webhooks from "./views/settings/settings-webhooks";
import WebhookCreate from "./views/settings/settings-webhooks/create";
import WebhookEdit from "./views/settings/settings-webhooks/edit";


import '../scss/dashboard.scss';

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<Root />}>
            <Route errorElement={<ErrorPage />}>
                <Route path="login/" element={<Navigate to={"accounts/login/?next=/dashboard/new/"} />} />
                <Route element={<ProtectedRoute />}>
                    <Route path="/" element={<DashboardContainer />} />
                    <Route path="analytics/" element={<AnalyticsContainer />}>
                        <Route path=":analyticId/" element={<AnalyticsDetail />} />
                    </Route>
                    <Route path="customers/:customerId/" element={<CustomerContainer />} />
                    <Route path="customers/" element={<CustomerContainer />} />
                    <Route path="customers/new" element={<CustomerNew />} />
                    <Route path="payments/:paymentId/" element={<PaymentContainer />} />
                    <Route path="payments/" element={<PaymentContainer />} />
                    <Route path="payments/new" element={<PaymentNew />} />
                    <Route path="plans/" element={<PlanContainer />}>
                        <Route path="new/" element={<PlanCreate />} />
                        <Route path=":planId/" element={<PlanDetail />} />
                    </Route>
                    <Route path="subscriptions/:subscriptionId/" element={<SubscriptionContainer />} />
                    <Route path="subscriptions/" element={<SubscriptionContainer />} />
                    <Route path="subscriptions/new" element={<SubscriptionNew />} />
                    <Route path="transactions/:transactionId/" element={<TransactionContainer />} />
                    <Route path="transactions/" element={<TransactionContainer />} />
                    <Route path="export/:exportId/" element={<ExportContainer />} />
                    <Route path="export/" element={<ExportContainer />} />
                    <Route path="settings/" element={<SettingsContainer />}>
                        <Route path="account/" element={<Account />} />
                        <Route path="apikeys/" element={<ApiKeys />} />
                        <Route path="apikeys/new" element={<ApiKeyCreate />} />
                        <Route path="billing/" element={<Billing />} />
                        <Route path="discounts/" element={<Discounts />} />
                        <Route path="discounts/new/" element={<DiscountCreate />} />
                        <Route path="paymentbuttons/" element={<PaymentButtons />} />
                        <Route path="paymentprocessors/" element={<PaymentProcessors />} />
                        <Route path="paymentprocessors/new/" element={<PaymentProcessorCreate />} />
                        <Route path="paymentprocessors/:id/" element={<PaymentProcessorEdit />} />
                        <Route path="plangroups/" element={<PlanGroups />} />
                        <Route path="plangroups/new/" element={<PlanGroupCreate />} />
                        <Route path="plangroups/:id/" element={<PlanGroupEdit />} />
                        <Route path="users/" element={<Users />} />
                        <Route path="users/:id/" element={<UserEdit />} />
                        <Route path="users/new/" element={<UserCreate />} />
                        <Route path="webhooks/" element={<Webhooks />} />
                        <Route path="webhooks/new/" element={<WebhookCreate />} />
                        <Route path="webhooks/:id/" element={<WebhookEdit />} />
                    </Route>
                    <Route path="superadmin/" element={<SuperAdmin />} />
                </Route>
                <Route path="*" element={<ErrorPage />} />
            </Route>
        </Route>
    ),
    { basename: "/dashboard/new/" }
);


ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode >
);
